import React from "react";
import styled from "styled-components";
import { Button, Card, Empty, Space, Statistic, Tag, Typography } from "antd";
import { ClockCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const WidgetCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
  }
`;

const MetricGrid = styled.div`
  display: grid;
  gap: 14px;
`;

const StageTagList = styled(Space)`
  margin-top: 12px;
`;

const LeadResponseWidget = ({ leadResponse, onOpenDrilldown }) => {
  if (!leadResponse) {
    return (
      <WidgetCard title="Lead Response">
        <Empty
          description="No lead response metrics for the selected filters"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </WidgetCard>
    );
  }

  return (
    <WidgetCard
      title="Lead Response"
      extra={<Tag color="blue">SLA {leadResponse.slaMinutes}m</Tag>}
      data-testid="lead-response-widget"
    >
      <MetricGrid>
        <Statistic
          title="Average Response Time"
          value={
            leadResponse.averageResponseMinutes === null
              ? "No response samples"
              : `${leadResponse.averageResponseMinutes} min`
          }
          prefix={<ClockCircleOutlined />}
          valueStyle={{ color: "#005249", fontWeight: 700 }}
        />
        {leadResponse.missingAverageReason && (
          <Text type="secondary">{leadResponse.missingAverageReason}</Text>
        )}
        <Statistic
          title="Waiting Beyond SLA"
          value={leadResponse.waitingBeyondSla || 0}
          prefix={<ExclamationCircleOutlined />}
          valueStyle={{
            color: leadResponse.waitingBeyondSla > 0 ? "#ff4d4f" : "#52c41a",
            fontWeight: 700,
          }}
        />
        <Statistic
          title="Qualified Without Quotes"
          value={leadResponse.qualifiedWithoutQuote || 0}
          valueStyle={{
            color: leadResponse.qualifiedWithoutQuote > 0 ? "#faad14" : "#52c41a",
            fontWeight: 700,
          }}
        />
        <Button
          type="link"
          size="small"
          onClick={() =>
            onOpenDrilldown?.(
              leadResponse.drilldowns?.qualifiedWithoutQuote ||
                "qualified_leads_without_quotes"
            )
          }
          disabled={!leadResponse.qualifiedWithoutQuote}
          style={{ paddingLeft: 0, alignSelf: "flex-start" }}
        >
          View unquoted qualified leads
        </Button>
        <StageTagList size={[8, 8]} wrap>
          {(leadResponse.stuckByStage || []).map((stage) => (
            <Tag key={stage.stage} color="purple">
              {formatStage(stage.stage)}: {stage.count}
            </Tag>
          ))}
        </StageTagList>
      </MetricGrid>
    </WidgetCard>
  );
};

function formatStage(stage) {
  return String(stage || "")
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export default LeadResponseWidget;
